import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GiftBrand, ShoppingCartItem } from "../models/GiftBrand";


interface GiftShoppingCartState {
  giftBrands: ShoppingCartItem[];
  loading: boolean;
  open: boolean;
  checkoutFormVisible: boolean;
  buyGiftsDrawerOpen: boolean;
}

const initialState: GiftShoppingCartState = {
  giftBrands: [],
  loading: false,
  open: false,
  checkoutFormVisible: false,
  buyGiftsDrawerOpen: false,
};
const giftShoppingCartSlice = createSlice({
  name: "giftShoppingCart",
  initialState,
  reducers: {
    addGiftBrand: (state: GiftShoppingCartState, action: PayloadAction<GiftBrand>) => {
  const existingItemIndex = state.giftBrands.findIndex(
    item => item.productId === action.payload.productId
  );

  if (existingItemIndex >= 0) {
    // If item already exists, increment quantity
    state.giftBrands[existingItemIndex].quantity += 1;
  } else {
    // If item doesn't exist, add it with quantity 1
    state.giftBrands.push({
      ...action.payload,
      quantity: 1,
      amount: 10 // Use provided amount or default to 10
    });
  }
},
    removeGiftBrand: (state:GiftShoppingCartState , action: PayloadAction<number>) => {
      state.giftBrands = state.giftBrands.filter(a=>a.productId !== action.payload);
    },
    setGiftBrands: (state:GiftShoppingCartState , action: PayloadAction<ShoppingCartItem[]>) => {
      state.giftBrands = action.payload;
    },
    clearGiftBrands: (state:GiftShoppingCartState ) => {
      state.giftBrands = [];
    },
    openShoppingCart: (state:GiftShoppingCartState ) => {
      state.open = true;
    },
    closeShoppingCart: (state:GiftShoppingCartState ) => {
      state.open = false;
    },
    openCheckoutForm: (state:GiftShoppingCartState ) => {
      state.checkoutFormVisible = true;
    },
    openBuyGiftsDrawer: (state:GiftShoppingCartState) => {
      state.buyGiftsDrawerOpen = true;
    },
    closeBuyGiftsDrawer: (state:GiftShoppingCartState) => {
      state.buyGiftsDrawerOpen = false;
    },
    closeCheckoutForm: (state:GiftShoppingCartState ) => {
      state.checkoutFormVisible = false;
    },
    updateAmount: (state, action: PayloadAction<{ productId: number; amount: number }>) => {
      const { productId, amount } = action.payload;
      const itemIndex = state.giftBrands.findIndex(item => item.productId === productId);
      if (itemIndex !== -1) {
        state.giftBrands[itemIndex].amount = amount;
      }
    },
    updateQuantity: (state, action: PayloadAction<{ productId: number; quantity: number }>) => {
  const { productId, quantity } = action.payload;
  const itemIndex = state.giftBrands.findIndex(item => item.productId === productId);
  if (itemIndex !== -1) {
    state.giftBrands[itemIndex].quantity = quantity;
  }
},
  },
});
export const { setGiftBrands, clearGiftBrands,addGiftBrand,removeGiftBrand,openShoppingCart,closeShoppingCart,openCheckoutForm,closeCheckoutForm,updateQuantity,updateAmount,
  openBuyGiftsDrawer, closeBuyGiftsDrawer
 } = giftShoppingCartSlice.actions;
export default giftShoppingCartSlice.reducer;